import React from 'react';

export function Icon(props: { filetype?: string }) {
    return <div data-filetype={props.filetype} className="filepicker-file-icon" />;
}
